'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { useAnalyticsConsent } from '@/components/shared/analytics-consent-provider'

export function CookieConsentBanner() {
  const { showBanner, accept, reject } = useAnalyticsConsent()

  if (!showBanner) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background px-4 py-4 sm:px-6"
    >
      <div className="wrap-wide flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground leading-relaxed">
          We don&apos;t set analytics cookies unless you accept. Either way we count your visit
          anonymously via a privacy-preserving hash, with no tracking data stored on your device;
          accepting enables cookie-based analytics on your account. Essential cookies are always on.{' '}
          <Link
            href="/privacy"
            className="underline transition-colors duration-200 hover:text-foreground"
          >
            Privacy Policy
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" onClick={reject} className="transition-colors duration-200">
            Reject
          </Button>
          <Button onClick={accept} className="transition-colors duration-200">
            Accept
          </Button>
        </div>
      </div>
    </div>
  )
}
